// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { billingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAddressInfoDisplay";
import { css } from "styled-components";

billingAddressInfoDisplayStyles.heading = {
    variant: "h5",
    forwardAs: "p",
};

billingAddressInfoDisplayStyles.editLink = {
    css: css`
        margin-top: 4px;
        margin-left: 32px;
    `,
    
};